const parseUrl = (url) => {
  if (url.length < 4 || url.includes(" ")) {
    return void 0;
  }
  try {
    return new URL(url);
  } catch {
    return void 0;
  }
};
export {
  parseUrl
};
//# sourceMappingURL=parseUrl.js.map
